export default {
  // Page metadata
  'meta.title': 'سروس کی شرائط - timer.today',
  'meta.description': 'timer.today آن لائن ٹائمنگ ٹولز پلیٹ فارم کے لیے سروس کی شرائط اور استعمال کا معاہدہ۔ ہماری سروس کے قواعد، صارف کے حقوق اور ذمہ داریوں کے بارے میں جانیں۔',

  // Page header
  'page.title': 'سروس کی شرائط',
  'page.lastUpdated': 'آخری تازہ کاری: {{date}}',
  'page.intro': 'timer.today میں خوش آمدید۔ یہ شرائط و ضوابط timer.today کی ویب سائٹ کے استعمال کے لیے قواعد و ضوابط کا خاکہ پیش کرتے ہیں، جو timer.today پر واقع ہے۔',

  // Section 1
  'section1.title': '۱. شرائط کی قبولیت',
  'section1.content': 'اس ویب سائٹ تک رسائی اور استعمال کرکے، آپ اس معاہدے کی شرائط اور فراہمی سے پابند ہونے کو قبول اور اس پر راضی ہیں۔ اگر آپ مذکورہ بالا کی پابندی کرنے پر راضی نہیں ہیں، تو براہ کرم اس سروس کو استعمال نہ کریں۔',

  // Section 2
  'section2.title': '۲. سروس کی تفصیل',
  'section2.intro': 'timer.today مفت آن لائن ٹائمنگ ٹولز فراہم کرتا ہے جن میں شامل ہیں:',
  'section2.timer': 'الٹی گنتی ٹائمر - پیداواری صلاحیت، کھانا پکانے اور وقت کے انتظام کے لیے حسب ضرورت ٹائمر',
  'section2.stopwatch': 'سٹاپ واچ - کھیلوں، تربیت اور درست ٹائمنگ کے لیے اعلیٰ درستگی ٹائمنگ ٹول',
  'section2.worldclock': 'عالمی گھڑی - عالمی ٹائم زونز کی حقیقی وقت میں نمائش',

  // Section 3
  'section3.title': '۳. استعمال لائسنس',
  'section3.intro': 'صرف ذاتی، غیر تجارتی عارضی دیکھنے کے لیے timer.today کو عارضی طور پر استعمال کرنے کی اجازت دی جاتی ہے۔ یہ لائسنس کی فراہمی ہے، ٹائٹل کی منتقلی نہیں، اور اس لائسنس کے تحت آپ نہیں کر سکتے:',
  'section3.item1': 'مواد میں ترمیم یا نقل کریں',
  'section3.item2': 'کسی تجارتی مقصد کے لیے یا کسی عوامی نمائش کے لیے مواد استعمال کریں',
  'section3.item3': 'ویب سائٹ پر موجود کسی سافٹ ویئر کو ریورس انجینئر کرنے کی کوشش کریں',
  'section3.item4': 'مواد سے کوئی کاپی رائٹ یا دیگر ملکیتی اشارے ہٹائیں',

  // Section 4
  'section4.title': '۴. رازداری اور ڈیٹا',
  'section4.intro': 'timer.today آپ کی رازداری کی حفاظت کے لیے پرعزم ہے:',
  'section4.item1': 'ہم ذاتی معلومات جمع یا محفوظ نہیں کرتے',
  'section4.item2': 'ٹائمر کی ترتیبات آپ کے براؤزر میں مقامی طور پر محفوظ ہوتی ہیں',
  'section4.item3': 'ہم صارف کے رویے یا استعمال کے نمونوں کو ٹریک نہیں کرتے',
  'section4.item4': 'ٹریکنگ کے مقاصد کے لیے کوئی کوکیز استعمال نہیں کی جاتیں',

  // Section 5
  'section5.title': '۵. دستبرداری',
  'section5.content': 'timer.today پر مواد \'جیسا ہے\' کی بنیاد پر فراہم کیا جاتا ہے۔ timer.today کوئی وارنٹی، ظاہر یا مضمر، نہیں دیتا اور اس طرح تاجرانہ پن، کسی خاص مقصد کے لیے موزونیت، یا دانشورانہ املاک کی خلاف ورزی یا حقوق کی دیگر خلاف ورزی کی مضمر وارنٹیوں یا شرائط سمیت لیکن ان تک محدود نہیں، تمام دیگر وارنٹیوں کو مسترد اور نفی کرتا ہے۔',

  // Section 6
  'section6.title': '۶. حدود',
  'section6.content': 'کسی بھی صورت میں timer.today یا اس کے سپلائرز کسی بھی نقصان (بشمول، بغیر حد کے، ڈیٹا یا منافع کے نقصان کے لیے نقصانات، یا کاروباری رکاوٹ کی وجہ سے) کے لیے ذمہ دار نہیں ہوں گے جو timer.today پر مواد کے استعمال یا استعمال میں ناکامی سے پیدا ہوتے ہیں، یہاں تک کہ اگر timer.today یا اس کے مجاز نمائندے کو زبانی یا تحریری طور پر اس طرح کے نقصان کے امکان کے بارے میں مطلع کیا گیا ہو۔',

  // Section 7
  'section7.title': '۷. مواد کی درستگی',
  'section7.content': 'timer.today پر ظاہر ہونے والے مواد میں تکنیکی، ٹائپوگرافیکل، یا فوٹوگرافک غلطیاں شامل ہو سکتی ہیں۔ timer.today اس بات کی ضمانت نہیں دیتا کہ اس کی ویب سائٹ پر موجود کوئی بھی مواد درست، مکمل، یا موجودہ ہے۔ timer.today کسی بھی وقت بغیر اطلاع کے اپنی ویب سائٹ پر موجود مواد میں تبدیلیاں کر سکتا ہے۔',

  // Section 8
  'section8.title': '۸. تبدیلیاں',
  'section8.content': 'timer.today کسی بھی وقت بغیر اطلاع کے اپنی ویب سائٹ کے لیے سروس کی ان شرائط پر نظر ثانی کر سکتا ہے۔ اس ویب سائٹ کو استعمال کرکے، آپ سروس کی شرائط کے اس وقت کے موجودہ ورژن سے پابند ہونے پر راضی ہو رہے ہیں۔',

  // Section 9
  'section9.title': '۹. رابطے کی معلومات',
  'section9.intro': 'اگر آپ کے پاس سروس کی ان شرائط کے بارے میں کوئی سوالات ہیں، تو براہ کرم ہم سے رابطہ کریں:',
  'section9.email': 'ای میل:',
  'section9.emailSubject': 'سروس کی شرائط کی انکوائری - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024۔ تمام حقوق محفوظ ہیں۔'
};
